/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import UserAvatarCircleIcon from '@atlaskit/icon/core/migration/person-avatar--user-avatar-circle';
import { N0, N20A, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { useImageState } from '../../hooks/use-image-state';

export type ProfilePictureProps = {
	testId?: string;
	src: string | undefined;
	size: number;
	className?: string;
};

const imgStyles = css({
	display: 'block',
	borderRadius: '50%',
});

export const ProfilePicture: React.ComponentType<ProfilePictureProps> = ({
	testId,
	src,
	size,
	className,
}) => {
	const state = useImageState(src || '');

	const displayImage = src && state === 'loaded';
	const displayFallback = src && state === 'error';
	const displaySkeleton = !displayImage && !displayFallback;

	return (
		<div
			data-testid={testId}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
			css={{
				width: size,
				height: size,
				...(displaySkeleton && {
					borderRadius: '50%',
					backgroundColor: token('color.background.neutral', N20A),
				}),
				'& svg, & img': {
					width: size,
					height: size,
				},
			}}
		>
			{displayImage && (
				<img data-testid={testId && `${testId}--img`} src={src} css={imgStyles} alt="" />
			)}
			{displayFallback && (
				<UserAvatarCircleIcon
					spacing="spacious"
					testId={testId && `${testId}--fallback`}
					label=""
					color={token('color.text.subtlest', N90)}
					LEGACY_secondaryColor={token('color.text.inverse', N0)}
				/>
			)}
		</div>
	);
};
